import API from './../api';
import {
    DOOR_LOCKS_RESORT_LOCK_ACCOUNT_ENDPOINT,
    DOOR_LOCKS_RESORT_LOCK_ACCOUNT_DISCONNECT_ENDPOINT,
} from './../endpoints';

export default {

    namespaced: true,

    state() {
        return {
            resortLockAccount: null,
        };
    },

    getters: {
        resortLockAccount: (state) => state.resortLockAccount,
    },

    mutations: {
        gotResortLockAccount(state, response) {
            state.resortLockAccount = response.data;
        },
        purgeResortLockAccount(state) {
            state.resortLockAccount = null;
        }
    },

    actions: {
        async fetchResortLockAccount({ commit }) {
            commit('gotResortLockAccount', await API.get(DOOR_LOCKS_RESORT_LOCK_ACCOUNT_ENDPOINT()));
        },
        async disconnectResortLockAccount({ commit }) {
            commit('purgeResortLockAccount', await API.post(DOOR_LOCKS_RESORT_LOCK_ACCOUNT_DISCONNECT_ENDPOINT()));
        },
    },

};
